var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"play-button",class:{ 'play-button--light': !_vm.isDark },attrs:{"size":"20","title":"미리보기"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("mdi-play-circle-outline")])
}
var staticRenderFns = []

export { render, staticRenderFns }